
import {
    Box
} from '@chakra-ui/react';
import { useSelector } from "react-redux";
import _ from 'lodash';

import TicketsPerService from "../../components/organization/reports/TicketsPerService";
import { getReportDescription } from '../../store/helpers';
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const TicketsPerServicePage = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const { data } = reportsData;

  const reportTitle = `${reportIndex}. Tickets Per Service`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      <Box mb="20px">
        <h1>{reportTitle}</h1>
        <p>{getReportDescription(reportRange).TicketsPerService}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        <TicketsPerService reportIndex={reportIndex} data={data} />
      ) : <Box mt={10}>
              <p>No data available in this report</p>
            </Box>}
    </Box>
  );
};

export default TicketsPerServicePage;
  
